var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "loading-fade"
    }
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-mask",
    on: {
      "touchmove": function touchmove($event) {
        $event.preventDefault();
      }
    }
  }), _c('div', {
    staticClass: "loading-content"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": _vm.color
    }
  }), _vm.message ? _c('p', {
    staticClass: "loading-tips",
    style: {
      'color': _vm.color
    }
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };